import Vue from 'vue'
import ClickOutside from '@/directives/click-outside'

Vue.directive('click-outside', ClickOutside);
